import { useState, useCallback } from "react";
import { useApiWithHandling } from "./useApiWithHandling";
import { AirframeComponentSlotDto } from "../types/airframeComponentSlot";

export const useAirframeAvailableSlots = () => {
  const { get } = useApiWithHandling();
  const [slots, setSlots] = useState<AirframeComponentSlotDto[]>([]);
  const [loading, setLoading] = useState(false);

const fetchAvailableSlots = useCallback(
  async (airframeId: string, componentType: string) => {
    if (!airframeId || !componentType) {
      setSlots([]);
      return;
    }

    setLoading(true);

    try {
      const typeString = String(componentType).trim();

      const url = `/api/airframes/${airframeId}/available-slots?componentType=${encodeURIComponent(typeString)}`;

      const response = await get<AirframeComponentSlotDto[]>(url, {
        showLoader: false,
        showErrorSnackbar: false,
        showSuccessSnackbar: false,
      });

      const slotsData =
        response?.data ?? (Array.isArray(response) ? response : []);

      setSlots(slotsData);
    } catch (error) {
      console.error("Failed to load slots", error);
      setSlots([]);
    } finally {
      setLoading(false);
    }
  },
  [get]
);

  return {
    slots,
    loading,
    fetchAvailableSlots,
  };
};
